<template>
  <nuxt-link :to="{name: 'cabinet-sim'}" class="sidebar-link --sim-card" active-class="active">
    <span class="sidebar-link_text">SIM-карты</span><span v-if="count > 0" class="sidebar-link_count">{{ count }}</span>
  </nuxt-link>
</template>

<script>
import { get, call } from 'vuex-pathify'
export default {
  name: 'SimMenuLink',
  async fetch () {
    await this.updateCounter()
  },
  computed: {
    count: get('cabinetSimRequests/count')
  },
  mounted () {
    this.timer = setInterval(() => {
      this.updateCounter()
    }, 60 * 1000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    updateCounter: call('cabinetSimRequests/updateCount')
  }
}
</script>

<style scoped>

</style>
